import { render } from "./EventSecurityView.vue?vue&type=template&id=19b2b986&scoped=true&ts=true"
import script from "./EventSecurityView.vue?vue&type=script&lang=ts"
export * from "./EventSecurityView.vue?vue&type=script&lang=ts"

import "./EventSecurityView.vue?vue&type=style&index=0&id=19b2b986&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b2b986"]])

export default __exports__